module.exports = __webpack_public_path__ + "static/media/mock-app-detail.a898801b.svg";